export const getErrorMessage = (error, defaultMessage = 'Something went wrong. Please try again.') => {
  // No error or already a plain string — return as-is for display or empty UI state.
  if (!error || typeof error === 'string') {
    return error;
  }

  // Apollo Client mutation/query failures.
  if (error.graphQLErrors?.length) {
    return error.graphQLErrors.map((e) => e.message).join(', ');
  }

  // gql-service and other callers that reject with a top-level GraphQL errors array.
  if (error.errors?.length) {
    return error.errors.map((e) => e.message).join(', ');
  }

  const responseData = error.response?.data ?? error.networkError?.result;
  // GraphQL errors nested in an HTTP response body (e.g. axios or Apollo networkError).
  if (responseData?.errors?.length) {
    return responseData.errors.map((e) => e.message).join(', ');
  }
  // REST endpoints that return { message } on 4xx/5xx (e.g. stripe payment-intents).
  if (responseData?.message) {
    return responseData.message;
  }

  // Stripe card validation errors from useStripeUpgrade.
  if (error.confirm?.message) {
    return error.confirm.message;
  }
  // Upgrade flow errors already normalised to { upgrade: { message } }.
  if (error.upgrade?.message) {
    return error.upgrade.message;
  }

  // Standard Error objects and plain { message } fallbacks.
  return error.message || defaultMessage;
};
